import { useCallback, useEffect, useState } from "react";
import { api } from "../lib/api";

export const useServerStatus = (interval = 30000) => {
  const [status, setStatus] = useState(null);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const [s, st] = await Promise.all([api.get("/server/status"), api.get("/stats")]);
      setStatus(s.data);
      setStats(st.data);
    } catch {
      setStatus({ online: false });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, interval);
    return () => clearInterval(id);
  }, [refresh, interval]);

  return { status, stats, loading, refresh };
};
